import {homeIcon, passengerCarIcon, personIcon} from '@ace-de/ui-components';
import {mafCases} from '@ace-de/eua-entity-types';

export const mafCasesIcons = {
    [mafCases.VEHICLE]: passengerCarIcon,
    [mafCases.PERSON]: personIcon,
    [mafCases.HOUSEHOLD]: homeIcon,
};
